import { Component, OnInit } from "@angular/core";
import { MessageService } from "../../services/message.service";

@Component({
	selector: "app-token-confirmed",
	template: `
		<div class="jumbotron jumbotron-fluid r-25">
		<h2 class="ml-3">{{"registration_completed" | translate}}</h2>
			<div class="container mt-3">
				<div class="alert alert-success" role="alert">
				<h4>{{"token_validated" | translate}}</h4>
				<p>{{"reg_email_instructions" | translate}}</p>
				</div>
			</div>
		</div>
	`,
	styles: []
})
export class TokenConfirmedComponent implements OnInit {
	constructor(private messageService : MessageService) {}

	ngOnInit() {
    this.messageService.reportMessage("Confirm Token Code");
  }
}
